import {Navigate, Route, Routes} from 'react-router-dom';
import {useConfig} from '@tinct/core-config';
import {EditIntegrationsPage} from "../pages/edit-integrations-page/edit-integrations-page";
import {IntegrationOauthCallbackPage} from "../pages/integration-oauth-callback-page/integration-oauth-callback-page";
import {GoogleAdsIntegrationPage} from "../pages/google-ads-integration-page/google-ads-integration-page";
import {LinkedinAdsIntegrationPage} from "../pages/linkedin-ads-integration-page/linkedin-ads-integration-page";

export const IntegrationsRoutes = () => {
  const {isFeatureEnabled} = useConfig();

  return (
    <Routes>
      <Route path="/oauth/callback" element={<IntegrationOauthCallbackPage />} />
      {/* Feature-flagged: without the flag the `*` catch-all sends the URL
          back to the integrations list. */}
      {isFeatureEnabled('googleAdsIntegration') && (
        <Route path="/google-ads/:integrationId" element={<GoogleAdsIntegrationPage />} />
      )}
      {isFeatureEnabled('linkedinAdsIntegration') && (
        <Route path="/linkedin-ads/:integrationId" element={<LinkedinAdsIntegrationPage />} />
      )}
      <Route path="/" element={<EditIntegrationsPage />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};
